import React from 'react';

import styles from '../css/CoveragePPUInfoFee.module.css';

export const WaitingPeriodRow = ({ title = '', description = '' }) => (
  <div className={styles.waitingPeriodRowContainer}>
    <span className={styles.waitingPeriodRowTitle}>
      {title}
    </span>

    <span className={styles.waitingPeriodRowDescription}>
      {description}
    </span>
  </div>
);
